import type { MaybeElementRef } from '@vueuse/core'
import type { Ref } from 'vue'
import { unref } from 'vue'

type ScrollTarget = MaybeElementRef | string

export const useScrollTo = () => {
  const scrollTo = (target: ScrollTarget, options: ScrollIntoViewOptions = {}) => {
    const element = typeof target === 'string'
      ? document.querySelector(target)
      : unref(target as Ref<HTMLElement | null>)

    element?.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
      ...options,
    })
  }

  return { scrollTo }
}
